import { z } from "zod";
export const apiKeyNameSchema = z.string({
    required_error: 'API key name is required.',
    invalid_type_error: 'API key name must be a string.'
}).min(1, 'API key name cannot be empty.').max(128, 'API key name cannot exceed 128 characters.').regex(/^[a-zA-Z0-9\-_.]+$/, {
    message: 'API key name can only contain alphanumeric characters, hyphens, underscores, and periods.'
});
export const apiKeyDescriptionSchema = z.string({
    invalid_type_error: 'API key description must be a string.'
}).max(1024, 'Description cannot exceed 1024 characters.').optional();
export const apiKeyIdSchema = z.string({
    required_error: 'API key ID is required.',
    invalid_type_error: 'API key ID must be a string.'
}).min(1, 'API key ID cannot be empty.');
export const apiKeySchema = z.object({
    id: apiKeyIdSchema,
    name: apiKeyNameSchema,
    description: apiKeyDescriptionSchema,
    status: z.enum([
        'Active',
        'Disabled'
    ]).optional(),
    value: z.string().optional(),
    createdDate: z.date()
});
export const usagePlanKeySchema = z.object({
    id: apiKeyIdSchema,
    name: apiKeyNameSchema,
    type: z.literal('API_KEY').optional(),
    value: z.string().optional()
});
export const apiKeyCreatedSchema = apiKeySchema.extend({
    value: z.string()
});
export const createApiKeyBodySchema = z.object({
    name: apiKeyNameSchema,
    description: apiKeyDescriptionSchema.optional()
});
